import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';
import { SubscriptionPlanComponent } from 'src/app/user/subscription-plan/subscription-plan.component';
import Swal from 'sweetalert2';
import { AddUserComponent } from '../add-user/add-user.component';
import { get } from 'jquery';

@Component({
    selector: 'app-franchse-user-details',
    templateUrl: './franchse-user-details.component.html',
    styleUrls: ['./franchse-user-details.component.scss'],
})
export class FranchseUserDetailsComponent implements OnInit {
    // isLoading:boolean = true;
    breadCrumbItems: Array<{}>;
    UserId: any;
    planId: any;
    usersData: any;
    currentUser: any;
    EPPCount: any;
    AACount: any;
    AuctionCount: any;
    AllCount;
    any;
    PPCount: any;
    TPCount: any;
    isLoading: boolean;
    EmailAreaAlert: any;
    EmailTP: any;
    EmailEPP: any;
    EmailPP: any;
    EmailAuction: any;
    SMSPP: any;
    SMSAreaAlert: any;
    status: any;
    allCount: any;
    count: any;
    length: any;
    LRSPending: any;
    LRSReceived: any;
    AllLRSCount: any;
    constructor(
        private route: ActivatedRoute,
        private dialog: MatDialog,
        private router: Router,
        private generalService: GeneralService
    ) {
        if (this.router.getCurrentNavigation()) {
            if (this.router.getCurrentNavigation().extras.state) {
                const state = this.router.getCurrentNavigation().extras.state;
                console.log(state, 'State');
                this.UserId = state['UserId'];
                this.planId = state['planId'];
                localStorage.setItem('UserId', this.UserId);
                localStorage.setItem('PlanId', this.planId);
                console.log('this.UserId', this.UserId);
                console.log('this.planId', this.planId);
            } else {
                if (localStorage.getItem('UserId')) {
                    this.UserId = localStorage.getItem('UserId');
                    this.planId = localStorage.getItem('PlanId');
                    this.router.navigate(['/users/users-users-details'], {
                        state: { id: localStorage.getItem('UserId') },
                    });
                } else {
                    this.router.navigate(['/users/users-users']);
                }
            }
        }
    }

    async ngOnInit() {
        this.currentUser = this.generalService.getcurrentUser();

        this.breadCrumbItems = [
            { label: 'Users List', path: '/users/users-users' },
            {
                label: 'User Details',
                path: '/users/users-users-details/',
                active: true,
            },
        ];
        this.isLoading = true;
        const getUsersDetails: any = await this.getUsersDetails();
        const AllServiceCounts: any = await this.AllServiceCounts();
        const AllServiceCount: any = await this.AllServiceCount();
        const getCount: any = await this.getCount();
        this.isLoading = false;
        // if (
        //     getUsersDetails &&
        //     getUsersDetails.status === 200 &&
        //     AllServiceCounts &&
        //     AllServiceCounts.status === 200 &&
        //     AllServiceCount &&
        //     AllServiceCount.status === 200 &&
        //     getCount &&
        //     getCount.status === 200
        // ) {
        //     this.isLoading = false;
        //     console.log('✅ All API calls successful!');
        // }
        // this.LRs();
        // this.lrscount();
    }
    async getCount(): Promise<any> {
        this.generalService.getAllCount(this.UserId).subscribe((res: any) => {
            this.count = res.result;
            console.log('Count', this.count);
        });
    }
    async AllServiceCounts(): Promise<any> {
        this.generalService
            .AllServiceCount(this.UserId)
            .subscribe((res: any) => {
                this.AllCount = res.result;
                this.AACount = this.AllCount.AreaAlertSubCount;
                this.TPCount = this.AllCount.TPSubCount;
                this.PPCount = this.AllCount.PPSubCount;
                this.EPPCount = this.AllCount.EppSubCount;
                this.AuctionCount = this.AllCount.AuctionSubCount;
                console.log('AllServiceCount', res);
            });
    }
    async AllServiceCount(): Promise<any> {
        this.generalService
            .getAllServiceCount(this.UserId)
            .subscribe((res: any) => {
                this.allCount = res.result;
                this.EmailAreaAlert = res.result.AreaAlertEmailCount;
                this.EmailTP = res.result.TPEmailCount;
                this.EmailEPP = res.result.EPPEmailCount;
                this.EmailPP = res.result.PPEmailCount;
                this.EmailAuction = res.result.AuctionEmailCount;
                this.SMSPP = res.result.PPSMSCount;
                this.SMSAreaAlert = res.result.AreaAlertSMSCount;
            });
    }
    // lrscount() {
    //   this.generalService.LRSCount(this.UserId).subscribe((res: any) => {
    //     this.AllLRSCount = res.result[0].TotalCount;
    //     this.LRSReceived = res.result[0].ReceivedReqCount;
    //     console.log("nkjdsnvkds", res);
    //     console.log("PendingReqCount", this.LRSPending);
    //     console.log("ReceivedReqCount", this.LRSReceived);
    //   });
    // }
    // LRs() {
    //   this.generalService.getLRSUserList(this.UserId).subscribe((res: any) => {
    //     this.length = res.TotalCount;
    //     console.log("leght", this.length);
    //   });
    // }
    close() {
        this.dialog.closeAll();
    }
    ViewEmailPP() {
        this.router.navigate(['/users/pp-email-alert'], {
            state: { id: this.UserId },
        });
    }
    viewReceipt() {
        console.log('View Property Id', this.planId);
        this.router.navigate(['users/users-users-details/receipts/'], {
            state: { UserId: this.UserId, PlanId: this.planId },
        });
        this.close();
    }
    ViewAuctionalert() {
        this.router.navigate(['/users/auctionAlert'], {
            state: { UserId: this.UserId, PlanId: this.planId },
        });
        console.log('plan', this.planId);
    }
    UserDistrict() {
        this.router.navigate(['/users/userDistrcit'], {
            state: { UserId: this.UserId },
        });
    }
    ViewEmailAuctionalert() {
        this.router.navigate(['/users/auction-email-alert'], {
            state: { id: this.UserId },
        });
    }
    ViewEmailTP() {
        this.router.navigate(['/users/tp-email-alert'], {
            state: { id: this.UserId, PlanId: this.planId },
        });
    }
    ViewEmailEPPalert() {
        this.router.navigate(['/users/epp-email-alert'], {
            state: { id: this.UserId, PlanId: this.planId },
        });
    }
    ViewPPalert() {
        this.router.navigate(['/users/pp-sms-alert'], {
            state: { id: this.UserId, PlanId: this.planId },
        });
    }
    areaAlert() {
        this.router.navigate(['/users/area-alert-list']),
            { state: { UserId: this.UserId, PlanId: this.planId } };
        console.log('Area', this.planId);
    }
    ViewProperty() {
        this.router.navigate(['/users/view-property'], {
            state: {
                Userid: this.UserId,
                PlanId: this.planId,
                edit: false,
                Status: this.status,
            },
        });
        console.log('________------', this.planId);
    }
    ViewEPPalert() {
        this.router.navigate(['/users/view-epp'], {
            state: {
                id: this.UserId,
                Status: this.status,
                PlanId: this.planId,
            },
        });
    }
    ViewEmailArealert() {
        this.router.navigate(['/users/area-email-alert'], {
            state: { UserId: this.UserId, PlanId: this.planId },
        });
    }
    viewLRS() {
        this.router.navigate(['/users/lrs-user-details'], {
            state: { id: this.UserId },
        });
    }
    ViewSMSalert() {
        this.router.navigate(['/users/area-sms-alert'], {
            state: { id: this.UserId, PlanId: this.planId },
        });
    }
    callAlert() {
        this.router.navigate(['/users/users-users-details/call-alert'], {
            state: { id: this.UserId },
        });
        this.dialog.closeAll();
    }
    ViewTPalert() {
        this.router.navigate(['/users/view-tp-list'], {
            state: {
                id: this.UserId,
                Status: this.status,
                PlanId: this.planId,
            },
        });
        console.log(this.planId, 'rjoehfkdjbfkjbd');
    }
    viewPlan() {
        console.log(this.planId, 'rjoehfkdjbfkjbd');

        this.router.navigate(['/users/subscriptionplan'], {
            state: { UserId: this.UserId, PlanId: this.planId },
        });
    }
    ngOnDestroy() {
        // localStorage.removeItem('UserId');
        // localStorage.removeItem('PlanId');
    }
    async getUsersDetails(): Promise<any> {
        this.generalService.getUsersDetails(this.UserId).subscribe(
            (res: any) => {
                if (res) {
                    this.usersData = res.data;
                    console.log(this.usersData, 'Ureeess;fneigehij');
                    this.status = res.data.user.Status;
                    console.log('Statys', this.status);
                    // this.isLoading = false;
                }
            },
            (error) => {
                this.isLoading = false;
                Swal.fire({
                    title: error.status,
                    text: 'Internal Server Error',
                    type: 'error',
                });
            }
        );
    }

    editProfile() {
        console.log('Opening dialog with data:', this.usersData);

        const dialogRef = this.dialog.open(AddUserComponent, {
            width: '600px',
            data: {
                userData: this.usersData.user,
                app: this.usersData.username,
                isEdit: true,
            },
            autoFocus: false,
            maxHeight: '90vh',
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.getUsersDetails();
            }
        });
    }
}
